import { Expose, plainToInstance, Type } from "class-transformer";
import {
  IsDate,
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsString,
  IsOptional,
  ValidateNested,
} from "class-validator";
import { OnboardingStepType } from "./onboarding-step-type.enum";
import { DesignProjectOnboardingStepProjectElement } from "./design-project-onboarding-step-project-element.entity";

export class OnboardingStep {
  public static from(onboardingStep: any) {
    return plainToInstance(OnboardingStep, onboardingStep, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  id!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  designProjectId!: string;

  @Expose()
  @IsEnum(OnboardingStepType)
  stepType!: OnboardingStepType;

  @Expose()
  @IsInt()
  position!: number;

  @Expose()
  @IsInt()
  stage!: number;

  @Expose()
  @IsInt()
  percentComplete!: number;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  updatedTs!: Date;

  @Expose()
  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => DesignProjectOnboardingStepProjectElement)
  designProjectOnboardingStepElements?: DesignProjectOnboardingStepProjectElement[];
}
